var map = {
	"./2.png": "79d5",
	"./bg.jpg": "21d0",
	"./bg1.jpg": "594f",
	"./bg2.jpg": "e463",
	"./bg3.jpg": "926b",
	"./bg4.jpg": "a178",
	"./bg5.jpg": "6ef1",
	"./bgQQ.jpg": "fb27",
	"./bgRB.png": "6634",
	"./envelope1.png": "2861",
	"./envelope2.png": "6787",
	"./envelope3.png": "f902",
	"./film.png": "a9dd",
	"./finger.png": "a618",
	"./finger1.png": "b236",
	"./large1.jpg": "e27e",
	"./large2.jpg": "e61e",
	"./large3.jpg": "8b03",
	"./large4.jpg": "a094",
	"./large5.jpg": "4e27",
	"./large6.jpg": "bc7e",
	"./large7.jpg": "08cd",
	"./letter.png": "6e46",
	"./logo.png": "6e25",
	"./logo1.png": "9658",
	"./logo2.png": "4dbb",
	"./message.png": "206b",
	"./message1.png": "f3ad",
	"./message10.png": "3c5e",
	"./message2.png": "18bd",
	"./message3.png": "2714",
	"./message4.png": "cd1f",
	"./message5.png": "4768",
	"./message6.png": "fac0",
	"./message7.png": "0f19",
	"./message8.png": "eeb9",
	"./message9.png": "5625",
	"./paper.png": "cc70",
	"./pen.png": "9f5d",
	"./phone.png": "ddc7",
	"./poster.jpg": "b155",
	"./signal.png": "f430",
	"./slide1.jpg": "a6c9",
	"./slide10.jpg": "6758",
	"./slide11.jpg": "1916",
	"./slide12.jpg": "a870",
	"./slide2.jpg": "e253",
	"./slide3.jpg": "f5f7",
	"./slide4.jpg": "80a6",
	"./slide5.jpg": "4ac4",
	"./slide6.jpg": "c71b",
	"./slide7.jpg": "b7de",
	"./slide8.jpg": "c543",
	"./slide9.jpg": "fa47",
	"./slideText.jpg": "35f1",
	"./tips.png": "545f",
	"./titleImg.png": "faf8",
	"./titleImg2.png": "623d",
	"./wine.png": "1eca",
	"./years.png": "1bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7bba";